import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getValueFromLanguageObject } from "../../store";

class Breadcrumb extends Component {
  redirectToRoutes = () => {
    const { title, orderId } = this.props;

    const strProducts = getValueFromLanguageObject("str_products")
      ? getValueFromLanguageObject("str_products")
      : "Products";

    const strCheckout = getValueFromLanguageObject("checkout")
      ? getValueFromLanguageObject("checkout")
      : "CheckOut";

    const strCartPage = getValueFromLanguageObject("cart_page")
      ? getValueFromLanguageObject("cart_page")
      : "Cart Page";

    const strContactUs = getValueFromLanguageObject("str_contact_us")
      ? getValueFromLanguageObject("str_contact_us")
      : "Contact Us";

    const strAboutUs = getValueFromLanguageObject("str_about_us")
      ? getValueFromLanguageObject("str_about_us")
      : "About Us";

    const strOrders = getValueFromLanguageObject("str_orders")
      ? getValueFromLanguageObject("str_orders")
      : "Orders";

    const strEditOrder = getValueFromLanguageObject("str_edit_order")
      ? getValueFromLanguageObject("str_edit_order")
      : "Edit Order";

    const strDownloads = getValueFromLanguageObject("str_downloads")
      ? getValueFromLanguageObject("str_downloads")
      : "Downloads";

    const strAddressBook = "Address Book";

    if (title === strProducts) {
      return "/products";
    } else if (title === strCheckout) {
      return "/checkout";
    } else if (title === strCartPage) {
      return "/cart";
    } else if (title === strContactUs) {
      return "/contactus";
    } else if (title === strAboutUs) {
      return "/aboutus";
    } else if (title === strOrders) {
      return "/orders";
    } else if (title === strEditOrder) {
      return `/editorder/${orderId}`;
    } else if (title === strAddressBook) {
      return "/address";
    } else {
      return "/";
    }
  };

  render() {
    const { title, productName, parentCategory, subCategory } = this.props;
    const { id: parentCategoryId, name: parentCategoryName } =
      parentCategory || {};
    const { id: subCategoryId, name: subCategoryName } = subCategory || {};

    return (
      <div
        className="breadcrumb"
        style={{
          background: "#fff",
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          marginBottom: "12px", // <-- Only marginBottom, remove margin-top
          padding: "18px 24px",
          display: "flex",
          alignItems: "center",
          minHeight: "56px",
        }}
      >
        <div className="container">
          <nav aria-label="breadcrumb" style={{ width: "100%" }}>
            <ol
              style={{
                display: "flex",
                flexWrap: "wrap",
                listStyle: "none",
                margin: 0,
                padding: 0,
                fontSize: "13px",
                fontWeight: 500,
                color: "#1252c9",
              }}
            >
              <li style={{ marginRight: "12px" }}>
                <Link
                  to={`/`}
                  style={{
                    color: "#FF6A00",
                    textDecoration: "none",
                    fontWeight: 600,
                    fontSize: "13px",
                    padding: "2px 8px",
                    borderRadius: "8px",
                    transition: "background 0.2s",
                  }}
                  onMouseOver={(e) => (e.target.style.background = "#fff3e0")}
                  onMouseOut={(e) =>
                    (e.target.style.background = "transparent")
                  }
                >
                  {getValueFromLanguageObject("str_home")
                    ? getValueFromLanguageObject("str_home")
                    : "Home"}
                </Link>
              </li>
              {title && (
                <li style={{ marginRight: "12px" }}>
                  <span style={{ color: "#bdbdbd", margin: "0 6px" }}>/</span>
                  <Link
                    to={this.redirectToRoutes(title)}
                    style={{
                      color: "#1252c9",
                      textDecoration: "none",
                      fontWeight: 600,
                      fontSize: "13px",
                      padding: "2px 8px",
                      borderRadius: "8px",
                      transition: "background 0.2s",
                    }}
                    onMouseOver={(e) => (e.target.style.background = "#f5f5f7")}
                    onMouseOut={(e) =>
                      (e.target.style.background = "transparent")
                    }
                  >
                    {title}
                  </Link>
                </li>
              )}
              {parentCategoryId && (
                <li style={{ marginRight: "12px" }}>
                  <span style={{ color: "#bdbdbd", margin: "0 6px" }}>/</span>
                  <Link
                    to={`/c/${parentCategoryId}`}
                    style={{
                      color: "#1252c9",
                      textDecoration: "none",
                      fontWeight: 600,
                      fontSize: "13px",
                      padding: "2px 8px",
                      borderRadius: "8px",
                      transition: "background 0.2s",
                    }}
                    onMouseOver={(e) => (e.target.style.background = "#f5f5f7")}
                    onMouseOut={(e) =>
                      (e.target.style.background = "transparent")
                    }
                  >
                    {parentCategoryName}
                  </Link>
                </li>
              )}
              {subCategoryId && (
                <li style={{ marginRight: "12px" }}>
                  <span style={{ color: "#bdbdbd", margin: "0 6px" }}>/</span>
                  <Link
                    to={`/s/${subCategoryId}`}
                    style={{
                      color: "#1252c9",
                      textDecoration: "none",
                      fontWeight: 600,
                      fontSize: "13px",
                      padding: "2px 8px",
                      borderRadius: "8px",
                      transition: "background 0.2s",
                    }}
                    onMouseOver={(e) => (e.target.style.background = "#f5f5f7")}
                    onMouseOut={(e) =>
                      (e.target.style.background = "transparent")
                    }
                  >
                    {subCategoryName}
                  </Link>
                </li>
              )}
              {productName && (
                <li style={{ marginRight: "12px" }}>
                  <span style={{ color: "#bdbdbd", margin: "0 6px" }}>/</span>
                  <Link
                    to="#"
                    style={{
                      color: "#1252c9",
                      textDecoration: "none",
                      fontWeight: 600,
                      fontSize: "13px",
                      padding: "2px 8px",
                      borderRadius: "8px",
                      transition: "background 0.2s",
                    }}
                    onMouseOver={(e) => (e.target.style.background = "#f5f5f7")}
                    onMouseOut={(e) =>
                      (e.target.style.background = "transparent")
                    }
                  >
                    {productName}
                  </Link>
                </li>
              )}
            </ol>
          </nav>
        </div>
      </div>
    );
  }
}

export default Breadcrumb;
